import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const relationshipsToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.RELATIONSHIPS,
  iFrameSrcUrl: '/relationships',
  micrositeUrl: 'relationships',
  title: {
    id: 'relationshipsToolkit.title',
    defaultMessage: 'Build Stronger, Healthier Relationships',
    description: 'Microsite page title',
  },
  featureFlag: 'isRelationshipsToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/strengthening-social-connection-2',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
  ],
  page: '202608 relationships',
  trackUTMParams: {
    utm_campaign: 'Aug826',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'Strengthening Relationships',
  },
  shouldSupportSpanish: false,
  shouldHideForInternational: false,
}
